import React from 'react'
import { Outlet } from 'react-router-dom'
import "../../app/styles/styles.css"
import Header from '../../app/components/Header/Header'
import Footer from '../../app/components/Footer/Footer'

function RootLayout() {
    return (
        <>
            <Header />
            <div className='main-wraper'>
                <Outlet />
            </div>
            <Footer />
        </>
    )
}

export default RootLayout